// Accordion expand/collapse functionality
export function initAccordions() {
    const accordionItems = document.querySelectorAll('.accordion-item');

    accordionItems.forEach((item) => {
        const trigger = item.querySelector('.accordion-trigger') as HTMLButtonElement;
        const content = item.querySelector('.accordion-content') as HTMLElement;
        const icon = item.querySelector('.accordion-icon') as HTMLElement;

        if (!trigger || !content) return;

        trigger.addEventListener('click', () => {
            const isExpanded = trigger.getAttribute('aria-expanded') === 'true';

            // Close all other accordion items
            accordionItems.forEach((otherItem) => {
                if (otherItem !== item) {
                    const otherTrigger = otherItem.querySelector('.accordion-trigger') as HTMLButtonElement;
                    const otherContent = otherItem.querySelector('.accordion-content') as HTMLElement;
                    const otherIcon = otherItem.querySelector('.accordion-icon') as HTMLElement;

                    otherTrigger?.setAttribute('aria-expanded', 'false');
                    otherContent?.classList.add('hidden');
                    otherIcon?.classList.remove('rotate-180');
                }
            });

            // Toggle current item
            trigger.setAttribute('aria-expanded', String(!isExpanded));

            if (isExpanded) {
                // Collapse
                content.classList.add('hidden');
                icon?.classList.remove('rotate-180');
            } else {
                // Expand
                content.classList.remove('hidden');
                icon?.classList.add('rotate-180');
            }
        });

        // Keyboard support
        trigger.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                trigger.click();
            }
        });
    });
}
